import { render, staticRenderFns } from "./EmptyFeed.vue?vue&type=template&id=0c5b2380&scoped=true&"
import script from "./EmptyFeed.vue?vue&type=script&lang=ts&"
export * from "./EmptyFeed.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyFeed.vue?vue&type=style&index=0&id=0c5b2380&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5b2380",
  null
  
)

export default component.exports